import React, { FC, useState } from 'react';

import logo from '../../image/logo.svg';
import logoBg from '../../image/logo-bg.svg';
import menuOpen from '../../image/menu.svg';
import menuRemove from '../../image/menu-remove.svg';

import styled from 'styled-components';
import { Container } from '../styled/styled';

const HeaderStyled = styled.div`
  padding: 20px 0;
  height: 90px;
  img {
    max-width: 250px;
    width: 100%;
  }
  .menu {
    display: none;
  }
  .menu__image {
    display: none;
  }
  .menu__imageNone {
    display: none;
  }

  @media (max-width: 992px) {
    height: auto;
    padding: 10px 0;
    .inner img {
      max-width: 200px;
    }
    .menu {
      margin-left: auto;
      display: block;
      width: 50px;
      height: 30px;
      position: relative;
    }
    .menu::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      margin: 0 auto;
      background: url(${menuOpen}) no-repeat center;
      width: 100%;
      height: 100%;
      z-index: 1111;
    }
    .menu__remove {
      margin-left: auto;
      display: block;
      width: 50px;
      height: 30px;
      position: relative;
    }
    .menu__remove::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      margin: 0 auto;
      background: url(${menuRemove}) no-repeat center;
      width: 100%;
      height: 100%;
      z-index: 1111;
    }
    .navigate {
      display: none;
    }
    .navigate__block {
      width: 100vw;
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      left: 0;
      right: 0;
      top: 0%;
      bottom: 0;
      height: 100vh;
      background: #fff;
      z-index: 1110;
    }
    .navigate__block ul {
      width: 90%;
      margin-top: 200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .menu__image {
      max-width: 100% !important;
      width: 100% !important;
      left: 0;
      right: 0;
      top: 20%;
      display: block;
      position: fixed;
      z-index: 1111;
    }
    .menu__imageNone {
      display: none;
    }
  }
  @media (max-width: 660px) {
    .header__item a {
      font-size: 30px;
      line-height: 47px;
    }
  }
  @media (max-width: 560px) {
    .navigate__block ul {
      flex-direction: column;
    }
    .header__item a {
      font-size: 34px;
      line-height: 67px;
    }
  }
  @media (max-height: 560px){
    .menu__image {
      max-width: 70% !important;
      margin: 10px auto;
    }
  }
`;

const HeaderInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 600px) {
    img {
      max-width: 150px;
      width: 100%;
    }
  }
  @media (max-height: 560px){
    img {
      max-width: 130px;
    }
  }
`;

const HeaderNavigate = styled.div`
  margin-left: auto;
  max-width: 690px;
  width: 100%;
  ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  @media (max-width: 992px){
    max-width: 100%;
  }
`;

const HeaderItem = styled.li`
  margin: 0;
  p {
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    line-height: 47px;
    text-align: justify;
    color: #000000;
    position: relative;
  }
  p::after {
    content: '';
    position: absolute;
    right: 0;
    left: 0;
    top: 100%;
    margin: 0 auto;
    width: 0%;
    height: 5px;
    background: linear-gradient(
      90.04deg,
      rgba(36, 101, 199, 0) -1.3%,
      rgba(171, 25, 222, 0.435) 30.06%,
      rgba(36, 199, 130, 0.31) 55.03%,
      rgba(207, 210, 27, 0.3) 79.47%,
      rgba(207, 210, 27, 0) 99.67%
    );
    transition: 0.3s;
  }
  p:hover::after {
    width: 100%;
  }
`;

interface HeaderProps {
  slideTo: (number: number) => void;
  swiperActive: number;
}

export const Header: FC<HeaderProps> = ({ slideTo, swiperActive }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <HeaderStyled>
      <Container>
        <HeaderInner>
          {swiperActive ? <img src={logo} alt="" /> : null}
          <HeaderNavigate className={menuOpen ? 'navigate__block' : 'navigate'}>
            <ul>
              <HeaderItem onClick={() => setMenuOpen(!menuOpen)}>
                <p className={swiperActive === 1 ? 'active' : ''} onClick={() => slideTo(2)}>
                  About us
                </p>
              </HeaderItem>
              <HeaderItem onClick={() => setMenuOpen(!menuOpen)}>
                <p className={swiperActive === 2 ? 'active' : ''} onClick={() => slideTo(3)}>
                  Our portfolio
                </p>
              </HeaderItem>
              <HeaderItem onClick={() => setMenuOpen(!menuOpen)}>
                <p className={swiperActive === 3 ? 'active' : ''} onClick={() => slideTo(4)}>
                  Contact
                </p>
              </HeaderItem>
            </ul>
          </HeaderNavigate>
          <img className={menuOpen ? 'menu__image' : 'menu__imageNone'} src={logoBg} alt="" />
          <div
            onClick={() => setMenuOpen(!menuOpen)}
            className={menuOpen ? 'menu__remove' : 'menu'}></div>
        </HeaderInner>
      </Container>
    </HeaderStyled>
  );
};
